import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import "./LoginPage.css";

const ResetPasswordPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post(`/auth/reset-password/${token}`, { password });
      setSuccess(true);
    } catch {
      setError("Invalid or expired link.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-title">Set New Password</h2>
        {error && <p className="login-error">{error}</p>}
        {success ? (
          <>
            <p className="login-success">Password updated successfully.</p>
            <button className="login-button" onClick={() => navigate("/login")}>
              Back to Login
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="login-input"
            />
            <button type="submit" className="login-button">Change Password</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
